import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { SwpppPublicSite } from '../../shared'
import { DataService } from '../../shared/data/data.service'
import { Services } from '../../shared/services'

@Component({
    selector: 'app-swppp-public-site',
    templateUrl: './swppp-public-site.component.html',
    standalone: true,
})
export class SwpppPublicSiteComponent implements OnInit {
    site?: SwpppPublicSite
    missing = false
    private data: DataService

    constructor(
        private route: ActivatedRoute,
        services: Services,
    ) {
        this.data = services.data
    }

    ngOnInit() {
        const token = this.route.snapshot.paramMap.get('token')
        this.data.get<SwpppPublicSite>('/api/SwpppPublic/GetSite?token=' + token).subscribe({
            next: site => (this.site = site),
            error: () => (this.missing = true),
        })
    }
}
